var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-form",
            { ref: "formNumerations" },
            [
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _c(
                "base-card",
                [
                  _c("v-card-title", [
                    _vm._v("Resoluciones de facturación electrónica"),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "cliente",
                                attrs: {
                                  items: _vm.detailClients,
                                  "item-text": "text",
                                  "item-value": "IdCompania",
                                  label: "Compañia",
                                  "prepend-inner-icon": "mdi-sitemap",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  filter: "",
                                  "search-input": "",
                                  required: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    _vm.isAdmin
                                      ? {
                                          key: "prepend-item",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "search-field",
                                                            attrs: {
                                                              placeholder:
                                                                "Buscar",
                                                              "prepend-inner-icon":
                                                                "mdi-magnify",
                                                              "hide-details":
                                                                "",
                                                            },
                                                            model: {
                                                              value: _vm.search,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.search =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "search",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        }
                                      : null,
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.dataNumerations.IdCompania,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataNumerations,
                                      "IdCompania",
                                      $$v
                                    )
                                  },
                                  expression: "dataNumerations.IdCompania",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _vm.isAdmin
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-2",
                                      staticStyle: {
                                        "background-color": "rgb(204 33 40)",
                                        color: "white !important",
                                      },
                                      on: {
                                        click:
                                          _vm.validateClientToGetNumerations,
                                      },
                                    },
                                    [_vm._v(" Buscar ")]
                                  )
                                : _vm._e(),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "GRAY" },
                                  on: {
                                    click:
                                      _vm.validateClientToUpdateNumerations,
                                  },
                                },
                                [_vm._v(" Actualizar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-alert",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.successUpdateAlert,
                                  expression: "successUpdateAlert",
                                },
                              ],
                              attrs: { type: _vm.updateAlertType, text: "" },
                            },
                            [_vm._v(" " + _vm._s(_vm.msgUpdateAlert) + " ")]
                          ),
                          _vm.isAdmin
                            ? _c(
                                "v-alert",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.successAlert,
                                      expression: "successAlert",
                                    },
                                  ],
                                  attrs: { type: _vm.alertType, text: "" },
                                },
                                [_vm._v(" " + _vm._s(_vm.msgAlert) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }